export default __webpack_public_path__ + "static/media/bed.71ef0e6e.svg";